import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import CustomLoading from "../../components/CustomLoading";
import { useDispatch, useSelector } from "react-redux";
import { selectAuth, selectBranchId, setActiveTab } from "../../redux/features/authSlice";
import { useLocation } from "react-router-dom";
import { useGetMerchantListQuery } from "../../redux/api/merchantApi/merchantApi";
import CustomModal from "../../components/CustomModal";
import { useGetPaymentRequestListQuery, useUpdatePaymentRequestMutation } from "../../redux/api/paymentApi/paymentApi";
import { FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import { IAuthUser } from "../../redux/features/authSlice/authSlice.types";
import { useGetOperatorProfileQuery } from "../../redux/api/profileApi/profileApi";
import jwt_decode from 'jwt-decode';

const statusColor = {
    InProgress: "bg-[#FF8C00]/10 text-[#FF8C00]",
    Completed: "bg-[#3CB043]/10 text-[#3CB043]",
    Cancelled: "bg-[#C00000]/10 text-[#C00000]",
    Requested: "bg-[#927aff]/10 text-[#927aff]",
};

const options = [
    {
        title: "Requested",
        value: "Requested",
    },
    {
        title: "In Progress",
        value: "InProgress",
    },
    {
        title: "Completed",
        value: "Completed",
    },
    {
        title: "Cancelled",
        value: "Cancelled",
    },
];

const MerchantList = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const [filterText, setFilterText] = useState("");
    const branch_id = useSelector(selectBranchId);
    const { data: merchantList, isLoading: merchantLoading } =
        useGetMerchantListQuery(branch_id);
    const [paymentsModal, setPaymentsModal] = useState(false);
    const [requestList, setRequestList] = useState([]);
    const [merchantId, setMerchantId] = useState(null);
    const { data: paymentRequestList, isLoading: paymentRequestLoading } = useGetPaymentRequestListQuery(merchantId);
    const { token } = useSelector(selectAuth);
    const authData: IAuthUser = token ? jwt_decode(token) : null;
    const { data: profileData, isLoading: profileLoading } = useGetOperatorProfileQuery(authData?.id);
    const permissions: string[] = profileData?.permissions ? JSON.parse(profileData?.permissions) : [];
    const [paymentStatusModal, setPaymentStatusModal] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState('Requested');
    const [paymentStatusId, setPaymentStatusId] = useState(null);
    const [updatePaymentRequestStatus, statusResult] = useUpdatePaymentRequestMutation();


    const handleUpdate = async () => {
        const data = {
            payment_status: paymentStatus,
        }
        try {
            await updatePaymentRequestStatus({ data, id: paymentStatusId }).unwrap();
            toast.success("Payment Status Updated!");
            setPaymentStatusModal(false);
            setPaymentStatus('Requested');
            setPaymentStatusId(null);
        } catch (error) {
            console.log(error);
            toast.error(error?.data?.message || "Something went wrong!");
        }
    }

    const columns = [
        {
            name: 'Id',
            selector: row => row?.id,
            sortable: true,
        },
        {
            name: 'Company Name',
            selector: row => row.company_name,
            sortable: true,
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Contact Number',
            selector: row => row.contact_number,
            sortable: true,
        },
        {
            name: 'Address',
            selector: row => row.address,
            sortable: true,
        },
        {
            name: "Status",
            cell: (row) => (
                <div className={`py-1 w-20 text-center rounded ${row.isActive ? "bg-success/10 text-success" : "bg-attention/10 text-attention"}`}>
                    {row.isActive ? "Active" : "Inactive"}
                </div>
            ),
            sortable: true,
        },
        {
            name: "Action",
            cell: (row) => (
                <div onClick={() => {
                    setMerchantId(row?.id);
                    setPaymentsModal(true);
                }} className={`flex flex-row gap-2 items-center justify-center py-1 w-20 text-center rounded border bg-secondary/10 border-secondary text-secondary cursor-pointer transition-all hover:bg-secondary hover:animate-pulse hover:text-white`}>
                    Payments
                </div>
            ),
        },
    ];

    const paymentsColumns = [
        {
            name: "Id",
            selector: (row) => row?.id,
            sortable: true,
        },
        {
            name: "Bank Name",
            selector: (row) => row?.bank_name,
            sortable: true,
        },
        {
            name: "Branch Name",
            selector: (row) => row?.bank_branch,
            sortable: true,
        },
        {
            name: "Bank Account Name",
            selector: (row) => row?.bank_acc_name,
            sortable: true,
        },
        {
            name: "Bank Account Number",
            selector: (row) => row?.bank_acc_no,
            sortable: true,
        },
        {
            name: "Bank Routing Number",
            selector: (row) => row?.bank_routing_no,
            sortable: true,
        },
        {
            name: "Bkash Number",
            selector: (row) => row?.bkash_no,
            sortable: true,
        },
        {
            name: "Amount",
            selector: (row) => row?.amount,
            sortable: true,
        },
        {
            name: "Payment Status",
            cell: (row) => (
                <div
                    className={`py-1 w-20 text-center rounded ${statusColor[row?.payment_status]
                        }`}
                >
                    {row?.payment_status}
                </div>
            ),
            sortable: true,
        },
        {
            name: "Action",
            cell: (row) => (
                <div
                    onClick={() => {
                        if (permissions?.includes("AssignRider") || profileData?.isManager) {
                            if (row.payment_status === "Requested" || row.payment_status === "InProgress") {
                                setPaymentStatus(row?.payment_status);
                                setPaymentStatusId(row?.id)
                                setPaymentStatusModal(true);
                            } else if (row.payment_status === 'Completed') {
                                toast.info("This payment is completed!");
                            } else {
                                toast.info("This payment is canceled!");
                            }
                        } else {
                            toast.info('You have not permitted!');
                        }
                    }}
                    className={`flex flex-row gap-2 items-center justify-center py-1 w-20 text-center rounded border bg-secondary/10 border-secondary text-secondary cursor-pointer transition-all hover:bg-secondary hover:animate-pulse hover:text-white`}
                >
                    <FaEdit /> Edit
                </div>
            ),
            allowOverflow: true,
            button: true,
            width: "116px",
        },
    ];

    const filteredMerchant = merchantList?.filter(
        item => item.name && item.name.toLowerCase().includes(filterText.toLowerCase()),
    )?.reverse();

    useEffect(() => {
        if (paymentRequestList) {
            setRequestList(paymentRequestList?.reverse());
        }
    }, [paymentRequestList]);

    useEffect(() => {
        if (pathname === "/merchant-list") {
            dispatch(setActiveTab("Merchant List"));
        }
    }, [dispatch, pathname]);
    return (
        <div className="w-full flex flex-col gap-10">
            <div className="bg-white shadow-lg rounded-lg p-4 justify-between flex gap-5">
                <div className="flex flex-col justify-between w-full">
                    <div className="text-2xl font-bold text-text_1 mb-5 md:mb-0">Merchant List</div>
                    <div className="flex flex-col md:flex-row gap-4 items-center">
                        <div className="flex flex-row gap-4 items-center w-full">
                            <input
                                type="text"
                                className="flex-grow p-2 w-full focus:ring-0 border-2 rounded-lg focus:border-secondary focus:outline-none"
                                placeholder={`Search by merchant name`}
                                onChange={(e) => setFilterText(e.target.value)}
                                value={filterText}
                            />
                            <button
                                disabled={!filterText}
                                onClick={() => {
                                    setFilterText("")
                                }}
                                className={`py-2 w-24 text-center border border-warning text-warning rounded bg-warning/10 flex items-center justify-center ${!filterText ? "" : "cursor-pointer transition-all hover:bg-warning hover:animate-pulse hover:text-white"}`}
                            >
                                Clear
                            </button>
                        </div>
                    </div>
                </div>
                <div className="h-40 hidden lg:flex">
                    <img
                        src="https://res.cloudinary.com/di23omfvx/image/upload/v1692428968/self_driving_car_Road_1_npjom3.gif"
                        alt="self drive"
                        className="h-full w-full"
                    />
                </div>
            </div>
            <div className="overflow-x-auto bg-white shadow-lg rounded-lg p-2">
                <DataTable
                    columns={columns}
                    data={filteredMerchant}
                    pagination
                    persistTableHead
                    highlightOnHover
                />
            </div>

            <CustomModal
                showModal={paymentsModal}
                setShowModal={setPaymentsModal}
                submitButton={false}
                title={"Payment Request List"}
            >
                <DataTable
                    columns={paymentsColumns}
                    data={requestList}
                    pagination
                    subHeader
                    persistTableHead
                    highlightOnHover
                />
            </CustomModal>

            <CustomModal
                showModal={paymentStatusModal}
                setShowModal={setPaymentStatusModal}
                submitButton={true}
                handleSubmit={handleUpdate}
                submitButtonText="Update"
                title={"Update Payment Status"}
                className="sm:min-w-[70%] md:min-w-[60%] lg:min-w-[25vw] xl:min-w-[20vw]"
            >
                <div className="w-full mt-2">
                    <select
                        id="status"
                        value={paymentStatus}
                        onChange={(e) => setPaymentStatus(e.target.value)}
                        className="w-full border-2 p-2 rounded-lg focus:outline-none focus:border-secondary"
                    >

                        {options?.map((option, i) => {
                            return (
                                <option key={i} value={option.value}>
                                    {option.title}
                                </option>
                            )
                        })}
                    </select>
                </div>
            </CustomModal>
            {(merchantLoading || statusResult?.isLoading || paymentRequestLoading || profileLoading) && <CustomLoading />}
        </div>
    );
};

export default MerchantList;
